import gql from "graphql-tag";

export const REGISTER_CLIENT = gql`
  mutation ($input: clientRegisterInput) {
    registerClient(input: $input) {
      email
    }
  }
`;
